import "./Card.scss";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

/** When `to` is omitted, `"#"`, or empty, the label is not a router link (parent row handles navigation). */
export default function Card({
  image,
  title,
  description,
  link,
  img,
  to = "#",
  imageFallback,
  onLinkClick,
  className = "",
}) {
  const navigable = Boolean(to && to !== "#" && !onLinkClick);
  const [imgSrc, setImgSrc] = useState(image);
  const isPlaceholderImage = typeof imgSrc === "string" && imgSrc.startsWith("data:image/svg+xml");
  const descText = typeof description === "string" ? description.trim() : "";

  useEffect(() => {
    setImgSrc(image);
  }, [image]);

  const rootClass = ["card", className].filter(Boolean).join(" ");

  return (
    <div className={rootClass}>
      <div className="imag">
        <figure className="imag__frame">
          <img
            src={imgSrc}
            alt=""
            className={isPlaceholderImage ? "card_img card_img--placeholder" : "card_img"}
            onError={() => {
              if (imageFallback && imgSrc !== imageFallback) setImgSrc(imageFallback);
            }}
          />
        </figure>
      </div>

      <h3>{title}</h3>
      {descText ? <p>{descText}</p> : null}

      <div className="link_flex">
        {onLinkClick ? (
          <button type="button" className="view_link view_link_btn" onClick={onLinkClick}>
            {link}
          </button>
        ) : navigable ? (
          <Link to={to} className="view_link">
            {link}
          </Link>
        ) : (
          <span className="view_link">{link}</span>
        )}
        <span className="aro">
          <img src={img} alt="" />
        </span>
      </div>
    </div>
  );
}
